// extracted by mini-css-extract-plugin
export var accordionGroupContainer = "L_ct";
export var accordionListContainer = "L_cw";
export var accordionListHeadlines = "L_cv";